<template>
    <div class="main-background filter-page-container" :style="{ height: pageHeight + 'px' }">
        <div class="filter-page-back-button" @click="$emit('setIsChangePage', 'home')">
            <chevron-left-icon class="back-button-icon" />
            <p class="back-button-text">Cart</p>
        </div>
        <div class="cart-page-container-list">
            <div v-for="item of cartElements.items" :key="item.id" class="cart-page-item" :style="{ height: listHeight + 'px' }">
                <img :src="item.img" alt="" class="cart-page-item-image" @click="onOpenProduct(item)">
                <div class="cart-page-item-info">
                    <button @click="deleteProduct(item)" class="delete-product-cart-button">
                        <x-icon class="delete-button-icon"/>
                    </button>
                    <p class="cart-page-item-name" @click="onOpenProduct(item)">{{ item.product_name }}</p>
                    <p class="cart-page-item-code">Code: {{ item.product_id }}</p>
                    <p class="cart-page-item-price">{{ item.mod_price }} USD</p>
                    <div class="product-counter-container">
                            <button :disabled="Number(item.qty_item) === 1" class="product-counter-button" @click="setChangeCounter('-', item)">
                                <minus-icon
                                class="product-counter-button-icon"/>
                            </button>
                            <input type="text" class="product-counter-input" @keyup.enter="handleEnterKey" v-model="item.qty_item" @input="validateInput(item)" :max="item.qty_product">
                            <button :disabled="Number(item.qty_item) === item.qty_product" class="product-counter-button" @click="setChangeCounter('+', item)">
                                <plus-icon
                                class="product-counter-button-icon"/>
                            </button>
                        </div>
                </div>
            </div>
        </div>
         <div class="bottom-filter-button-container">
            <div class="final-price-container">
            <p class="final-price">In total</p>
            <p class="final-price">{{ cartElements.sumTotal }} USD</p>
            </div>
                    <button 
                    v-if="this.cartElements.items.length"
                    class="filtration-button" 
                    @click="goToMakeOrderPage"
                    >
                    To order
                </button>
                    <button 
                        class="return-to-shop" 
                        @click="$emit('setIsChangePage', 'home')"
                        >
                        Return to shopping
                    </button>
              </div>
    </div>
</template>

<script>

import { ChevronLeftIcon, PlusIcon, MinusIcon, XIcon } from 'vue-feather-icons'
import { mapMutations } from "vuex"

export default {
    name: "cart-page",
    components: {
        ChevronLeftIcon, 
        PlusIcon,
        MinusIcon,
        XIcon
    },
    props: {
        addedToCardProducts: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            pageHeight: 0,
            listHeight: 0
        }
    },
    async mounted() {
        this.pageHeight = window.innerHeight - 60
        this.listHeight = window.innerHeight - 50 - 175
        window.scrollTo(0, 0);
        document.body.addEventListener('click', (event) => {
        let target = event.target
        target
      })
    },
    methods: {
        ...mapMutations(['addPerPage']),
        handleEnterKey() {
            const activeElement = document.activeElement
            if (activeElement.tagName === 'INPUT') {
            activeElement.blur()
            }
       },
        onOpenProduct(item) {
            this.$store.dispatch("getOneProduct", item.product_id);
            this.addPerPage('home')
            this.$emit("setIsChangePage", "productInfo");
        },
         validateInput(item) {
            item.qty_item = item.qty_item.replace(/\D/g, '');

             const numericValue = parseInt(item.qty_item);
            if (numericValue > item.qty_product) {
                item.qty_item = item.qty_product.toString();
            }
        },
        goToMakeOrderPage() {
            if (this.cartElements?.items?.length) {
                this.$emit('setIsChangePage', 'makeOrder')
            }
        },
        setChangeCounter(value, product) {
               let data = {
                product_id: product.product_id,
                order_id: this.getOrderId.id
            }
            if (value === '+') {
                this.$store.dispatch('getOneMoreProduct', JSON.stringify(data))
            } else {
                 this.$store.dispatch('getMinusProduct', JSON.stringify(data))
            }
        },
        deleteProduct(product) {
            let data = {
               product_id: product.product_id,
               order_id: this.getOrderId.id
            }
            try {
                this.$store.dispatch('deleteProductFromCart', JSON.stringify(data))
            } catch (error) {
                console.log(error.message)
            }
        }
    },
    computed: {
        cartElements() {
            return this.$store.getters.getCustomerCart;
        },
        getOrderId() {
            return this.$store.getters.getOrderId
        }
    },
    watch: {

    }
}
</script>

<style scoped>
.main-background {
    background: #fff;
}
.filter-page-back-button {
    position: relative;
    border-bottom: 1px solid #F0F0F0;
    padding: 18px;
    cursor: pointer;
}

.back-button-icon {
    position: absolute;
}

.back-button-text {
    text-align: center;
}

.filter-page-container {
    display: flex;
    flex-direction: column;
}
.bottom-filter-button-container {
  background: #FFF;
  box-shadow: 0px -4px 4px 0px rgba(0, 0, 0, 0.04);
  padding: 16px;
  margin-top: auto;
}

.filtration-button {
    padding: 12px;
    width: 100%;
    border-radius: 8px;
    background: #343745;  
    color: #FFF;
    text-align: center;
    font-family: Inter;
    font-size: 18px;
    font-weight: 600;
    line-height: 24px;
    border: none;
    cursor: pointer;
    margin-bottom: 10px;
}
.return-to-shop {
    padding: 12px;
    width: 100%;
    border-radius: 8px;
    background: #FFF;  
    color: #343745;
    text-align: center;
    font-family: Inter;
    font-size: 18px;
    font-weight: 600;
    line-height: 24px;
    border: none;
    cursor: pointer;
    margin-bottom: 10px; 
    border: 1px solid #343745;
}
.cart-page-container-list {
  display: flex;
  flex-direction: column;
  margin-top: 18px;
  height: 100%;
  overflow-y: scroll;
}
.cart-page-item {
    position: relative;
    display: flex;
    gap: 24px;
    padding: 6px 16px 16px 16px;
    border-bottom: 1px solid #F0F0F0;
}
.product-counter-container {
    display: flex;
    gap: 4px;
    margin-left: auto;
}
.product-counter-button {
    border: 1px solid #C4C4C4;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    cursor: pointer;
}
.product-counter-button-icon {
    width: 8px;
    height: 8px;
}
.product-counter-input {
    width: 40px;
    height: 24px;
    border-radius: 4px;
    background: #F0F0F0;
    border: none;
    text-align: center;
    outline-offset: 0;
    outline: 0;
    color: #707070;
    text-align: center;
    font-family: 'Lato', sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 16px;
}
.cart-page-item-image {
    border-radius: 12px;
    border: 1px solid #D2D6DB;
    width: 140px;
    height: 140px;
    cursor: pointer;
}
.cart-page-item-name {
    color: #333;
    font-family: Inter;
    font-size: 14px;
    font-weight: 500;
    line-height: 18px; 
    padding-right: 15px;
    cursor: pointer;
}
.cart-page-item-code {
    color: #707070;
    font-family: 'Lato', sans-serif;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    margin-top: 14px;
}
.cart-page-item-price {
   color: #343745;
    font-family: 'Lato', sans-serif;
    font-size: 14px;
    font-weight: 600;
    line-height: 20px; 
    margin-top: 19px; 
    margin-bottom: 7px;
}
.final-price-container {
    display: flex;
    justify-content: space-between;
}
.final-price {
  color: #121212;
    font-family: Inter;
    font-size: 16px;
    font-weight: 600;
    line-height: 20px;  
    margin-bottom: 5px; 
}

.delete-product-cart-button {
    position: absolute;
    top: 5px;
    right: 5px;
    background-color: transparent;
    border: none;
    cursor: pointer;
}
.delete-button-icon {
    color: #686868;
}

</style>